import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { clearStoredUser, getStoredUser, login as loginRequest, storeUser } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(getStoredUser());

  // Token süresi dolduğunda apiRequest bu olayı yayınlar — oturumu kapat, ProtectedRoute login'e yönlendirir
  useEffect(() => {
    function handleUnauthorized() {
      setUser(null);
    }
    window.addEventListener('auth:unauthorized', handleUnauthorized);
    return () => window.removeEventListener('auth:unauthorized', handleUnauthorized);
  }, []);

  async function login(email, password) {
    const result = await loginRequest(email, password);
    const nextUser = {
      token: result.token,
      userName: result.userName,
      email: result.email,
      role: result.role,
      customerId: result.customerId,
    };
    storeUser(nextUser);
    setUser(nextUser);
    return nextUser;
  }

  function logout() {
    clearStoredUser();
    setUser(null);
  }

  const value = useMemo(() => ({ user, login, logout }), [user]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}